import { render, staticRenderFns } from "./international-users.vue?vue&type=template&id=3e152d18&scoped=true"
import script from "./international-users.vue?vue&type=script&lang=js"
export * from "./international-users.vue?vue&type=script&lang=js"
import style0 from "./international-users.vue?vue&type=style&index=0&id=3e152d18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e152d18",
  null
  
)

export default component.exports